import { Select } from '@ts/storybook';

const EGRActions = [
  // geofencing
  { label: 'Geofencing enter zone', value: 'enterZone', disabled: false },
  { label: 'Geofencing exit zone', value: 'exitZone', disabled: false },
  {
    label: 'Geofencing presence in a zone',
    value: 'presence',
    disabled: false,
  },
  // concrete updates
  {
    label: 'Event upon status change',
    value: 'changeStatus',
    disabled: false,
  },
  {
    label: 'Event upon change location',
    value: 'changeLocation',
    disabled: false,
  },
  // TTEGRs
  {
    label: 'Event upon no status change',
    value: 'noChangeStatus',
    disabled: false,
  },
  {
    label: 'Event upon no change location',
    value: 'noChangeLocation',
    disabled: true,
  },
  {
    label: 'Event after timeout of event recording',
    value: 'eventAfterEvent',
    disabled: true,
  },
  // readings
  {
    label: 'Event upon selected reading type',
    value: 'selectedReading',
    disabled: false,
  },
  // crud
  { label: 'Event upon creation', value: 'creation', disabled: true },
  {
    label: 'Event upon decommission',
    value: 'decomission',
    disabled: true,
  },
  { label: 'Event upon update', value: 'update', disabled: false },
  { label: 'Event upon attach', value: 'linkSensor', disabled: true },
  { label: 'Event upon dettach', value: 'unlinkSensor', disabled: true },
];

const EGRActionSelector = (props: {
  value: string;
  requiredFields: string[];
  onChange: (value: any) => void;
  disabled: boolean;
}) => {
  return (
    <Select
      value={props.value}
      onChange={props.onChange}
      isReadOnly={props.disabled}
      label={'Action that triggers an event'}
      required={props.requiredFields.includes('actionLogicalId')}
      options={EGRActions}
    />
  );
};
export default EGRActionSelector;
